import {Button, Stack} from '@mui/material';
import React from 'react';

import {AlertModal} from 'presentation/components';
import {HelpCenterEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {useNavigate} from 'react-router-dom';
import {FacialBiometricAlreadyRegisteredModalProps} from './types';

const {alreadyRegisteredModal} = translations['pt-br'].privateFlow.profile.facialBiometric;

export function FacialBiometricAlreadyRegisteredModal({
	open,
	onClose,
}: FacialBiometricAlreadyRegisteredModalProps) {
	const navigate = useNavigate();

	function handleViewUnits() {
		onClose();
		navigate(HelpCenterEnum.SERVICE_POINTS_ADDRESSES);
	}

	return (
		<AlertModal
			open={open}
			onClose={onClose}
			variant="info"
			customIconName="info-filled"
			headerTitle={alreadyRegisteredModal.headerTitle}
			title={alreadyRegisteredModal.title}
			description={alreadyRegisteredModal.description}
			footerContent={
				<Stack direction="row" gap={2} width="100%">
					<Button onClick={onClose} variant="outlined" fullWidth size="large">
						{alreadyRegisteredModal.backButton}
					</Button>

					<Button onClick={handleViewUnits} variant="contained" fullWidth size="large">
						{alreadyRegisteredModal.viewUnitsButton}
					</Button>
				</Stack>
			}
		/>
	);
}
